import { NgModule }         from '@angular/core';
import { QuestionsService } from './questions.service';

@NgModule({
  providers: [QuestionsService]
})
export class QuestionModule { }
